import { FaToolbox, FaTasks, FaGithub, FaMailBulk } from 'react-icons/fa';
import FlappyIAImage from './images/FlappyIA.png';
import OthelloIAImage from './images/OthelloIA.png';
import GradientDescentImage from './images/GradientDescent.png';
import WGANGPImage from './images/WGANGP.png';
import VAEImage from './images/VAE.png';
import EtudePopulationMondiale from './images/EtudePopulationMondiale.png';
import QCMJump from './images/QCMJump.png';
import SevenWonders from './images/7Wonders.jpg';
import HBase from './images/HBase.png';
import ViolaJones from './images/ViolaJones.png';
import ScikitLearn from './images/scikit-learn.png';
import SortingAlgorithms from './images/SortingAlgorithms.png';
import { createLink } from '../toolbox';

const info = {
	name: ['Saunders Pierre', 'Saunders Pierre', 'Saunders Pierre', 'Saunders Pierre', 'Saunders Pierre', 'Пьер Сондерс'],
	languages: [
		{ name: 'English', code: 'GB' },
		{ name: 'Français', code: 'FR' },
		{ name: 'Deutsch', code: 'DE' },
		{ name: 'Español', code: 'ES' },
		{ name: 'Italiano', code: 'IT' },
		{ name: 'Россия', code: 'RU' }
	],

	social: [
		{ name: 'Codeberg', icon: FaGithub, url: 'https://codeberg.org/saundersp' },
		{ name: 'Mail', icon: FaMailBulk, url: 'mailto:pierre.saundersgb@gmail.com' }
	],

	menu: {
		home: ['Home', 'Accueil', 'Startseite', 'Inicio', 'Casa', 'Главная'],
		work: ['Works', 'Travaux', 'Werke', 'Obras', 'Opere', 'Работы'],
		contact: ['Contact', 'Contact', 'Kontakt', 'Contacte con', 'Contatta', 'Связаться с'],
		liveDemo: ['Live demo', 'Démo live', 'Live-Demo', 'Demostración en vivo', 'Dimostrazione dal vivo', 'Живая демонстрация'],
		source: ['Source Code', 'Code Source', 'Quellcode', 'Código fuente', 'Codice sorgente', 'Исходный код'],
		download_link: ['Download', 'Télécharger', 'Herunterladen', 'Descargar', 'Scaricare', 'Скачать'],
		work_in_progress: ['Project in progress', 'Projet en cours', 'Laufendes Projekt', 'Proyecto en curso', 'Progetto in corso', 'Незавершенный проект'],
		CV: ['Curriculum vitæ', 'Curriculum vitæ', 'Lebenslauf', 'Curriculum vitæ', 'Curriculum vitæ', 'Биографическая справка'],
		credits: [
			<>Made using React, {createLink('https://codeberg.org/saundersp/portfolio', 'Source Code')}</>,
			<>Site crée avec React, {createLink('https://codeberg.org/saundersp/portfolio', 'Code Source')}</>,
			<>Hergestellt mit React, {createLink('https://codeberg.org/saundersp/portfolio', 'Quellcode')}</>,
			<>Sitio web creado con React, {createLink('https://codeberg.org/saundersp/portfolio', 'Código fuente')}</>,
			<>Sito web creato con React, {createLink('https://codeberg.org/saundersp/portfolio', 'Codice sorgente')}</>,
			<>Веб-сайт, созданный с помощью React, {createLink('https://codeberg.org/saundersp/portfolio', 'Исходный код')}</>
		]
	},

	headerTagLine: [
		"Hello 👋 you've found me!\nI'm Saunders Pierre,\na mathematics 📈 and artificial intelligence 🤖 enthusiast",
		"Bonjour 👋 vous m'avez trouvé(e) !\nJe suis Saunders Pierre,\nun passionné de mathématiques 📈 et d'intelligence artificielle 🤖",
		'Hallo 👋 Sie haben mich gefunden!\nIch bin Saunders Pierre,\nein leidenschaftlicher Anhänger der Mathematik 📈 und der künstlichen Intelligenz 🤖',
		'Hola 👋 ¡Me has encontrado!\nSoy Saunders Pierre,\nun entusiasta de las matemáticas 📈 y la inteligencia artificial 🤖',
		'Ciao 👋 Mi hai trovato!\nSono Saunders Pierre,\nun appassionato di matematica 📈 e intelligenza artificiale 🤖',
		'Здравствуйте 👋 Вы нашли меня!\nЯ Сандерс Пьер,\nлюбитель математики 📈и искусственного интеллекта 🤖'
	],

	projects_icons: ['🔬', '🏫', '🚀'],
	projects_title: [
		['Research projects', 'School projects', 'Personal projects'],
		['Projets de recherche', 'Projets scolaires', 'Projets personnels'],
		['Forschungsprojekte', 'Schulprojekte', 'Persönliche Projekte'],
		['Proyectos de investigación', 'Proyectos escolares', 'Proyectos personales'],
		['Progetti di ricerca', 'Progetti scolastici', 'Progetti personali'],
		['Исследовательские проекты', 'Школьные проекты', 'Личные проекты']
	],

	projects: [
		[
			{
				title: "Wimmics's SemanticWebBenchmarker",
				service: ['Semantic Web', 'Web sémantique', 'Semantisches Web', 'Web semántica', 'Web semantico', 'Семантическая паутина'],
				desc: [
					'Platform to easily evaluate different RDF engines on different comparators',
					'Plateforme pour évaluer facilement différents moteurs RDF sur différents comparateurs',
					'Plattform zur einfachen Bewertung verschiedener RDF-Engines auf verschiedenen Vergleichsgeräten',
					'Plataforma para evaluar fácilmente diferentes motores RDF en diferentes comparadores',
					'Piattaforma per valutare facilmente diversi motori RDF su diversi comparatori',
					'Платформа для простой оценки различных движков RDF на различных компараторах'
				],
				techs: ['Docker', 'Bash', 'RDF', 'SPARQL'],
				imageIcon: FaTasks,
				src: 'https://codeberg.org/SemanticWebBenchmarker'
			}
		],
		[
			{
				title: 'OthelloIA',
				service: ['MiniMax', 'MiniMax', 'MiniMax', 'MiniMax', 'MiniMax', 'Minimax'],
				desc: [
					'Implementation of an AI playing Othello',
					"Implémentation d'une IA jouant au jeu d'Othello",
					'Implementierung einer Othello spielenden KI',
					'Implementación de una IA que juega a Otelo',
					'Implementazione di una IA che gioca a Otello',
					'Реализация искусственного интеллекта, играющего в Отелло'
				],
				techs: ['HTML', 'CSS', 'Javascript'],
				imageSrc: OthelloIAImage,
				src: 'https://codeberg.org/saundersp/OthelloIA',
				url: 'https://saundersp.codeberg.page/OthelloIA/'
			},

			{
				title: 'ESP32Manager',
				service: [
					'IoT / Machine learning',
					'IoT / Apprentissage automatique',
					'IoT / Maschinelles Lernen',
					'IoT / Aprendizaje automático',
					'IoT / Apprendimento automatico',
					'IoT / Машинное обучение'
				],
				desc: [
					'IoT Project to manage, handle, and predict anomalies on ESP32 boards',
					'Projet IoT pour configurer, gérer, et prédire des pannes de carte ESP32',
					'IoT-Projekt zur Verwaltung, Handhabung und Vorhersage von Anomalien auf ESP32-Boards',
					'Proyecto IoT para configurar, gestionar y predecir los fallos de la placa ESP32',
					'Progetto IoT per configurare, gestire e prevedere i guasti della scheda ESP32',
					'IoT-проект для конфигурирования, управления и прогнозирования отказов платы ESP32'
				],
				techs: ['VueJS', 'Arduino', 'Python', 'NodeJS', 'Scikit-Learn'],
				imageSrc: 'https://codeberg.org/saundersp/ESP32Manager/raw/branch/master/front/src/assets/logo.png',
				src: 'https://codeberg.org/saundersp/ESP32Manager'
			},

			{
				title: 'EtudePopulationMondiale',
				service: ['Data mining', 'Exploration de données', 'Data-Mining', 'Minería de datos', 'Estrazione di dati', 'Добыча данных'],
				desc: [
					'Study on the evolution of the global population',
					"Étude de l'évolution de la population mondiale",
					'Studie über die Entwicklung der Weltbevölkerung',
					'Estudio de la evolución de la población mundial',
					"Studio dell'evoluzione della popolazione mondiale",
					'Изучение эволюции населения мира'
				],
				techs: ['R', 'Jupyter', 'Bash', 'tidyverse'],
				imageSrc: EtudePopulationMondiale,
				src: 'https://codeberg.org/saundersp/EtudePopulationMondiale',
				url: 'https://nbviewer.org/urls/codeberg.org/saundersp/EtudePopulationMondiale/raw/branch/master/Study%20on%20the%20evolution%20of%20the%20global%20population.ipynb'
			},

			{
				title: 'HBaseMonitoring',
				service: ['Database', 'Base de données', 'Datenbank', 'Base de datos', 'Database', 'База данных'],
				desc: [
					'HBase Database Manager Technology Monitoring',
					'Veille technologique du gestionnaire de base de données HBase',
					'HBase Database Manager Technology Watch',
					'Vigilancia tecnológica del gestor de bases de datos HBase',
					'Orologio tecnologico del gestore di database HBase',
					'Наблюдение за технологией управления базами данных HBase'
				],
				techs: ['Java', 'Maven'],
				imageSrc: HBase,
				src: 'https://github.com/ThomasGauci/HBaseProjet'
			},

			{
				title: '7Wonders',
				service: ['Video Game', 'Jeu vidéo', 'Videospiel', 'Videojuego', 'Gioco video', 'Видеоигра'],
				desc: [
					'Command line implementation of the 7Wonders board game',
					'Implémentation en ligne de commande du jeu de plateau 7Wonders',
					'Kommandozeilenimplementierung des 7Wonders Brettspiels',
					'Implementación en línea de comandos del juego de mesa 7Wonders',
					'Implementazione a riga di comando del gioco da tavolo 7Wonders',
					'Реализация командной строки настольной игры 7Wonders'
				],
				techs: ['Java', 'Maven'],
				imageSrc: SevenWonders,
				src: 'https://github.com/RemiFELIN/7Wonders_By_Miagestics',
				download_url: 'https://github.com/RemiFELIN/7Wonders_By_Miagestics/archive/refs/tags/LivraisonFinale.zip'
			},

			{
				title: 'QCMJump',
				service: ['Video Game', 'Jeu vidéo', 'Videospiel', 'Videojuego', 'Gioco video', 'Видеоигра'],
				desc: [
					'Multiple choice quiz game with a platform game component',
					'Jeu de questionnaire à choix multiples avec une composante de jeu de plateforme',
					'Multiple-Choice-Quizspiel mit einer Plattformspielkomponente',
					'Juego de preguntas de opción múltiple con un componente de juego de plataformas',
					'Gioco a quiz a scelta multipla con una componente di gioco a piattaforme',
					'Игра-викторина с множественным выбором и компонентом игры-платформы'
				],
				techs: ['HTML', 'Javascript'],
				imageSrc: QCMJump,
				src: 'https://github.com/FulconisYan/QCMJump',
				url: 'https://fulconisyan.github.io/QCMJump'
			}
		],
		[
			{
				title: 'Scikit-Learn wannabe',
				service: [
					'Machine Learning',
					'Apprentissage automatique',
					'Maschinelles Lernen',
					'Aprendizaje automático',
					'Apprendimento automatico',
					'Машинное обучение'
				],
				desc: [
					'Implementation of several small widely used machine learning algorithms',
					"Implémentation de plusieurs petits algorithmes d'apprentissage automatique largement utilisés",
					'Implementierung mehrerer kleiner, weit verbreiteter Algorithmen für maschinelles Lernen',
					'Implementación de varios algoritmos de aprendizaje automático de pequeño tamaño ampliamente utilizados',
					'Implementazione di diversi piccoli algoritmi di apprendimento automatico ampiamente utilizzati',
					'Реализация нескольких небольших широко используемых алгоритмов машинного обучения'
				],
				techs: ['Python'],
				imageSrc: ScikitLearn
			},

			{
				title: 'Sorting algorithms',
				service: [
					'Computational complexity theory',
					'Théorie de la complexité',
					'Komplexitätstheorie',
					'Teoría de la complejidad',
					'Teoria della complessità',
					'Теория сложности'
				],
				desc: [
					'Implementation of several sorting algorithms of diverse complexity',
					'Implémentation de plusieurs algorithmes de tri de compléxités diverses',
					'Implementierung mehrerer Sortieralgorithmen mit unterschiedlicher Vollständigkeit',
					'Aplicación de varios algoritmos de ordenación de distinta complejidad',
					'Implementazione di diversi algoritmi di ordinamento con diverse complessità',
					'Реализация нескольких алгоритмов сортировки с различной сложностью'
				],
				techs: ['C/C++'],
				imageSrc: SortingAlgorithms,
				src: 'https://codeberg.org/saundersp/sorting_algorithms'
			},

			{
				title: 'ViolaJones',
				service: [
					'Face Recognition',
					'Reconnaissance faciale',
					'Gesichtserkennung',
					'Reconocimiento facial',
					'Riconoscimento facciale',
					'Распознавание лиц'
				],
				desc: [
					'Implementation of the ViolaJones algorithm using GPU programmation',
					"Implémentation de l'algorithme de ViolaJones en utilisant la programmation GPU",
					'Implementierung des ViolaJones-Algorithmus mit GPU-Programmierung',
					'Implementación del algoritmo ViolaJones mediante programación en la GPU',
					"Implementazione dell'algoritmo ViolaJones usando la programmazione su GPU",
					'Реализация алгоритма Виола-Джонса с помощью программирования на GPU'
				],
				techs: ['Python', 'C/C++', 'CUDA', 'Bash'],
				imageSrc: ViolaJones,
				src: 'https://codeberg.org/saundersp/ViolaJones'
			},

			{
				title: 'VAE',
				service: ['Deep learning', 'Apprentissage profond', 'Tiefes Lernen', 'Aprendizaje profundo', 'Apprendimento profondo', 'Глубокое обучение'],
				desc: [
					'Implementation of the Variational Auto Encoder',
					"Implémentation de l'encodeur automatique variationnel",
					'Implementierung des Variational Auto Encoders',
					'Implementación del codificador variacional automático',
					'Implementazione del codificatore variazionale automatico',
					'Реализация автоматического вариационного кодера'
				],
				techs: ['Python', 'PyTorch', 'Bash', 'Docker'],
				imageSrc: VAEImage,
				src: 'https://codeberg.org/saundersp/VariationalAutoEncoder',
				url: 'https://nbviewer.org/urls/codeberg.org/saundersp/VariationalAutoEncoder/raw/branch/main/Variational%20Auto%20Encoder.ipynb'
			},

			{
				title: 'WGAN-GP',
				service: ['Deep learning', 'Apprentissage profond', 'Tiefes Lernen', 'Aprendizaje profundo', 'Apprendimento profondo', 'Глубокое обучение'],
				desc: [
					'Implementation of the Wasserstein GAN with gradient penalty',
					'Implémentation du Wasserstein GAN avec pénalité de gradient',
					'Implementierung des Wasserstein-GANs mit Gradientenstrafe',
					'Implementación del GAN de Wasserstein con penalización de gradiente',
					'Implementazione di Wasserstein GAN con penalità di gradiente',
					'Реализация GAN Вассерштейна с градиентным штрафом'
				],
				techs: ['Python', 'Tensorflow'],
				imageSrc: WGANGPImage,
				src: 'https://codeberg.org/saundersp/wgan-gp'
			},

			{
				title: 'FlappAI',
				service: [
					'Genetic algorithm',
					'Algorithme génétique',
					'Genetischer Algorithmus',
					'Algoritmo genético',
					'Algoritmo genetico',
					'Генетический алгоритм'
				],
				desc: [
					'AI Playing Flappy Bird',
					'IA jouant à Flappy Bird',
					'KI Spielt Flappy Bird',
					'IA jugando a Flappy Bird',
					'AI che gioca a Flappy Bird',
					'ИИ играет в Flappy Bird'
				],
				techs: ['HTML', 'Sass', 'Javascript'],
				imageSrc: FlappyIAImage,
				url: 'https://saundersp.codeberg.page/FlappAI/',
				src: 'https://codeberg.org/saundersp/FlappAI'
			},

			{
				title: 'SimpleGradientDescent',
				service: ['Deep learning', 'Apprentissage profond', 'Tiefes Lernen', 'Aprendizaje profundo', 'Apprendimento profondo', 'Глубокое обучение'],
				desc: [
					'Implementation of gradient descent with different optimization methods',
					"Implémentation d'une descente de gradient avec diverses technique d'optimisation",
					'Implementierung des Gradientenabstiegs mit verschiedenen Optimierungsverfahren',
					'Aplicación del descenso de gradiente con diversas técnicas de optimización',
					'Implementazione della discesa del gradiente con varie tecniche di ottimizzazione',
					'Реализация градиентного спуска с использованием различных методов оптимизации'
				],
				techs: ['Python', 'Jupyter', 'Numpy', 'Matplotlib'],
				imageSrc: GradientDescentImage,
				src: 'https://codeberg.org/saundersp/SimpleGradientDescent',
				url: 'https://nbviewer.org/urls/codeberg.org/saundersp/SimpleGradientDescent/raw/branch/master/Linear%20Regression.ipynb'
			},

			{
				title: 'ToolboxModule',
				service: ['Javascript module', 'Module Javascript', 'Javascript-Modul', 'Módulo Javacsript', 'Modulo Javacsript', 'Модуль Javacsript'],
				desc: [
					'Module including several functions reusable for various projects',
					'Module incluant plusieurs fonctions réutilisables pour divers projets',
					'Modul mit mehreren Funktionen, die für verschiedene Projekte wiederverwendbar sind',
					'Módulo que incluye varias funciones reutilizables para varios proyectos',
					'Modulo che include diverse funzioni riutilizzabili per vari progetti',
					'Модуль, включающий несколько многократно используемых функций для различных проектов'
				],
				techs: ['Javascript', 'NodeJS'],
				imageIcon: FaToolbox,
				src: 'https://codeberg.org/saundersp/ToolboxModule'
			},

			{
				title: 'MarioSokoban',
				service: ['Video Game', 'Jeu vidéo', 'Videospiel', 'Videojuego', 'Gioco video', 'Видеоигра'],
				desc: [
					"A Mario's themed sokoban game",
					'Un jeu de Sokoban sur le thème de Mario',
					'Ein Sokoban-Spiel mit Marios Thema',
					'Un juego de Sokoban con temática de Mario',
					'Un gioco Sokoban sul tema di Mario',
					'Игра Сокобан на тему Марио'
				],
				techs: ['C++', 'SDL', 'Adobe Illustrator'],
				imageSrc: 'https://codeberg.org/saundersp/MarioSokoban/raw/branch/master/bin/data/menus/instructions_jeu.png',
				src: 'https://codeberg.org/saundersp/MarioSokoban',
				download_url: 'https://codeberg.org/saundersp/MarioSokoban/releases/download/1.0/MarioSokoban.zip'
			}

			/*
			{
				title: '', // Title of the project
				service: ['UK', 'FR', 'DE', 'ES', 'IT', 'RU'], // Category of work (JS/ML ...)
				desc: ['UK', 'FR', 'DE', 'ES', 'IT', 'RU'], // Description
				techs: [], // List of technologies used (Javascript / Python ...)
				imageSrc: '', // Link to a representative image [optional]
				imageIcon: , // Reflect F.A Icon object [optional]
				src: '', // Github link / Source code [optional]
				url: '', // Live demo [optional]
				download_url: '' // Download link [optional]
			}
			*/
		]
	]
};

export default info;
